import orderApi from '../api/order';
import productApi from '../api/product';
import { showInfoMessage, showErrorMessage } from '../dialogs';

export default {
    methods: {
        makeServiceAction(productId, boxnr, colli, repairReasonId) {
            productApi.setAdditionalInfoToProduct(
                productId,
                boxnr,
                colli,
                '',
                repairReasonId,
                '',
                ''
            );
            this.createServiceForProduct(productId);
        },
        makeErrorAction(productId, boxnr, colli, repairReasonId) {
            productApi
                .problem(productId, boxnr, colli, repairReasonId)
                .then(() => {
                    showInfoMessage(
                        'Status van ' + productId + ' aangepast naar SP.'
                    );
                    this.$router.push('/menu');
                })
                .catch(() => {
                    showErrorMessage('Status kon niet gewijzigd worden.');
                });
        },
        createServiceForProduct(productId) {
            orderApi
                .createServiceOrderFromProduct(productId)
                .then((response) => {
                    const orderData = data.data;
                    this.$router.push(
                        '/copyserviceorderproduct?orderId=' +
                            orderData.orderId +
                            '&productId=' +
                            productId +
                            '&typeId=' +
                            orderData.producttypeId
                    );
                });
        },
    },
};
